import type { ClusterRevision } from '@/generated/http-clients/v3ApiSchemas'
import { isProduction } from '@/scripts/environments'
import { Button, Icon, Popover, Skeleton, Text } from '@chakra-ui/react'
import type { CustomUserClaims, UserClaims } from '@okta/okta-auth-js'
import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type RevisionReviewControlsProps = Readonly<{
  user?: UserClaims<CustomUserClaims>
  revision?: ClusterRevision
}>

// Note: this component has to be nested inside a Popover.Root due to Popover.Trigger usage
export function RevisionReviewControls({
  user,
  revision,
}: RevisionReviewControlsProps) {
  const { t } = useTranslation()
  const isCurrentUserCreator = user?.email === revision?.rollout?.created_by
  const canReview = isProduction ? !isCurrentUserCreator : true

  if (!user || !revision) {
    return <Skeleton height="10" w="200px" />
  }

  if (canReview) {
    return (
      <Popover.Trigger asChild>
        <Button variant="solid">
          {t('revisionReview.reviewSubmission')}
          <Icon as={ChevronDown} mr="-1" />
        </Button>
      </Popover.Trigger>
    )
  }

  return (
    <Text fontSize="sm" maxW="200px" color="text.text-subtle">
      {t('revisionReview.selfApprovalRestriction')}
    </Text>
  )
}
